
import './CreateRecord.css';
import React, { Component,  } from 'react';
import { Layout, Menu, Breadcrumb, Col, Row, message } from 'antd';
import { Button,  Progress, Table, Tag, Form } from 'antd';
import { Typography, PageHeader, Divider, Upload } from 'antd';
import ImgCrop from 'antd-img-crop'
import { DatePicker, Space, Input, Select } from 'antd';
import { ProfileOutlined,NumberOutlined,TagOutlined, BankOutlined, UserOutlined,  CalendarOutlined} from '@ant-design/icons';
import axios from 'axios'
import moment from 'moment';


import {store} from './store'
const { Title } = Typography;
const { Option } = Select;
const { Header, Content, Footer } = Layout;

const { RangePicker } = DatePicker;
const {TextArea} = Input;
const { Column, ColumnGroup } = Table;

export default class DetailPage extends Component{
  constructor(props) {
    super(props)
  }

  formRef = React.createRef()
  state = {
    data: {},
    username: '',
    primary_class:'',
    secondary_class:'',
    imgContent:'',
    uploadedImg: {
      fileName: '',
      filePath:''
    },
    fileList: [
    ],
    reportList: []
  }


  componentWillMount() {
    let primary_class = this.props.match.params.primary_class
    // let secondary_class = this.props.match.params.secondary_class
    // console.log('sec')
    // console.log(secondary_class)
    this.setState({
      ...this.state,
      primary_class: primary_class,
      // secondary_class: secondary_class
    })

    
  }
  async componentDidMount() {

    let record_id = this.props.match.params.record_id
    let req_data = {
      record_id: record_id
    }
    let data = []
    await axios('/record/detail', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: req_data
    }).then( res => {
      let record = res.data.record
      let data = {
        ...record,
        record_image_urls: res.data.record_image_urls,
        record_report_urls: res.data.record_report_urls,
        key: 0,
        etc: record.etc.replace(' ', ', '),
      }
      this.setState({
        ...res.data.record,
        data: data,
        username: res.data.name,
        primary_class: res.data.record.primary_class,
        secondary_class: res.data.record.secondary_class,
      })

      let reportList = []
      let reportIdx = 1
      for (let url of res.data.record_report_urls){
        reportList.push({
          uid: String(reportIdx * -1),
          name: url.split('/')[url.split('/').length -1].split('_')[1],
          status: 'done',
          thumbUrl: "",
          url: '/' + url
        })
        reportIdx = reportIdx + 1
      }
      this.setState({
        ...this.state,
        reportList: reportList
      })


      let fileList = []
      let imageIdx = 1
      for (let url of res.data.record_image_urls){
        fileList.push({
          uid: String(imageIdx * -1),
          name: url.split('/')[-1],
          status: 'done',
          url: '/' + url,
          raw_url: url
        })
        imageIdx = imageIdx + 1
      }
      this.setState({
        ...this.state,
        fileList: fileList
      })

    });

    this.formRef.current.setFieldsValue({
      primary_class: this.state.primary_class,
      // secondary_class: this.state.secondary_class
    })
    this.formRef.current.setFieldsValue({
      secondary_class: this.state.secondary_class,
      // secondary_class: this.state.secondary_class
    })
    this.formRef.current.setFieldsValue({
      curriculum_step: this.state.curriculum_step,
    })
    this.formRef.current.setFieldsValue({
      date_range: [moment(this.state.start_at, "YYYY/MM/DD"), moment(this.state.end_at, "YYYY/MM/DD")],
    })
    this.formRef.current.setFieldsValue({
      institute: this.state.institute,
    })
    this.formRef.current.setFieldsValue({
      practice: this.state.practice,
    })
    this.formRef.current.setFieldsValue({
      competency: this.state.competency? this.state.competency.split(' ') : [],
    })
    this.formRef.current.setFieldsValue({
      etc: this.state.etc,
    })
    this.formRef.current.setFieldsValue({
      professor: this.state.professor,
    })
    this.formRef.current.setFieldsValue({
      professor_phone: this.state.professor_phone,
    })
    this.formRef.current.setFieldsValue({
      report: this.state.report,
    })

    // this.formRef.current.setFieldsValue({

    // })
  }
  secondaryHandler =(e) => {
    this.formRef.current.setFieldsValue({
      secondary_class: e
    })

  }

  formHandler1 = (e) => {
    this.formRef.current.setFieldsValue({
      curriculum_step: e
    })
  }

  onChange = ({fileList: newFileList}) => {
    let _newFileList = []
    for (let f of newFileList) {
      if (f.response) {
        _newFileList.push(f.response)
      } else {
        _newFileList.push(f)
      }
    }
    this.setState({
      ...this.state,
      fileList: _newFileList
    })
  }
  onChangeReport = ({fileList: newFileList}) => {
    let _newFileList = []
    for (let f of newFileList) {
      if (f.response) {
        _newFileList.push(f.response)
      } else {
        _newFileList.push(f)
      }
    }
    this.setState({
      ...this.state,
      reportList: _newFileList
    })
  }

  onPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };


  // classHandler =(e) => {
  //   console.log(e)
  //   this.setState({
  //     ...this.state,
  //     primary_class: e,
  //     secondary_class: ''
  //   })
  // }

  submitHandler = (e) => {
    if ((this.state.reportList.length == 0) &&(this.state.primary_class == '실습')){
      message.warning('실습 보고서가 첨부되지 않았습니다')
      return false
    }


    let recordData = {
      record_id: this.props.match.params.record_id, 
      start_at: e.date_range[0]._d.toLocaleString('ko-KR', {
        year:'numeric',
        month:'numeric',
        day:'numeric',
      }),
      end_at: e.date_range[1]._d.toLocaleString('ko-KR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }),
      institute: e.institute ,
      practice: e.practice, 
      professor:  e.professor,
      professor_phone:  e.professor_phone,
      report: e.report, 
      competency: e.competency.join(' '),
      etc: e.etc,
      primary_class: e.primary_class,
      secondary_class: e.secondary_class,
      curriculum_step: e.curriculum_step,
      record_image_ids: this.state.fileList.map( (x) => { return x.response ? x.response.record_image_id : x.url}),
      // record_report_ids: this.state.reportList.map( (x) => { return  x.response ? x.response.record_report_id: x.raw_url}),
      record_report_ids: this.state.reportList.map( (x) => { return  x.response ? x.response.record_report_id: x.url})
    }


    const formData = new FormData();

    axios("/record/modify", {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: recordData
    })
    .then( () => {
      window.location.href='/'
    })
    .catch( () => {
      return false
    })
  }


  render () {

    const get_data =  {
        name: this.state.username,
        key: '1',
        date: '2021/03/25',
        institute: '',
        content: '고양이 암컷 중성화',
        tags: ['GS', ],
        professor: '홍길동 교수',
        status: '승인 완료',
      }


      return (
      
      
      <Layout style={{ padding: '0 24px 24px' }}>
        <PageHeader
          className="site-page-header"
          onBack={() =>  window.location.href='/'}
          title={this.state.data.institute}
          subTitle="포트폴리오 기록"
        />
        <Content          
          className="site-layout-background"
          style={{
            padding: 24,
            margin: 0,
            minHeight: 280,
            background: '#fff'
          }}>
          <Form onSubmit={this.submitHandler} onFinish={this.submitHandler}
          ref={this.formRef}
          >
          {/* <Divider orientation="left">실습 내역 기록</Divider> */}
          {/* <Divider orientation="left">Fill rest</Divider> */}
          <Divider orientation="center">신규 포트폴리오</Divider>
          <Row>
            <Col flex="20%" className='row-title'>분류1</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="primary_class"
              rules={[{ required: true, message: '실습 분류1를 입력하세요' }]}
            >
              {true ?
              <Select name='primary_class' defaultValue={this.state.primary_class} disabled
                size="large"
              >
                <Option value='실습'>실습</Option>
                <Option value='활동'>활동</Option>
                <Option value='자기학습'>자기학습</Option>
              </Select>
              :
              ''
              }
            </Form.Item>

            </Col>
            <Col flex="20%" className='row-title'>분류2</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="secondary_class"
              rules={[{ required: true, message: '실습 분류2를 입력하세요' }]}
            > 
              {this.state.primary_class =='실습' ?  
                <Select
                name='secondary_class'
                defaultValue={this.state.secondary_class}
                size="large"
                onChange={this.secondaryHandler}
                >
                  <Option value='공공기관'>공공기관</Option>
                  <Option value='동물병원'>동물병원</Option>
                  <Option value='기타'>기타</Option>
                </Select>
              : ''}
              {this.state.primary_class =='활동' ?  
                <Select 
                name='secondary_class'
                defaultValue={this.state.secondary_class}
                size="large"
                onChange={this.secondaryHandler}
                >
                  <Option value='봉사활동'>봉사활동</Option>
                  <Option value='동아리활동'>동아리활동</Option>
                  <Option value='저널클럽'>저널클럽</Option>
                  <Option value='연구활동'>연구활동</Option>
                  <Option value='기타'>기타</Option>
                </Select>
              : ''}
              {this.state.primary_class =='자기학습' ?  
                <Select 
                name='secondary_class'
                defaultValue={this.state.secondary_class}
                size="large"
                onChange={this.secondaryHandler}
                >
                  <Option value='독서'>독서</Option>
                  <Option value='여행'>여행</Option>
                  <Option value='기타'>기타</Option>
                </Select>
              : ''}
            </Form.Item>

            </Col>
            <Col flex="20%" className='row-title'>학년 구분</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="curriculum_step"
              rules={[{ required: true, message: '학년 구분을 입력하세요' }]}
            >
              <Select
                name='curriculum_step'
                size="large"
                defaultValue={this.state.curriculum_step}
                onChange={this.formHandler1}
              >
                <Option value='prevet'>예과과정</Option>
                <Option value='preclinical'>본과 기초과정</Option>
                <Option value='clinical'>본과 임상과정</Option>
              </Select>
            </Form.Item>

            </Col>
          </Row>
          <Row>
          </Row>
          {this.state.primary_class == '실습' ? 
          <>
          <Row>
            <Col flex="20%" className='row-title'>실습 기간</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="date_range"
              rules={[{ required: true, message: '실습 기간 입력하세요' }]}
            >
              <RangePicker
                style={{
                  width:'100%'
                }}
                format="YYYY/MM/DD"
                name='date_range'
                size="large"
                prefix={<CalendarOutlined />} 
                defaultValue={[moment(this.state.start_at, "YYYY/MM/DD"), moment(this.state.end_at, "YYYY/MM/DD")]}
                dateRender={current => {
                  const style = {};
                  if (current.date() === 1) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                  }
                  return (
                    <div className="ant-picker-cell-inner" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>실습 기관</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="institute"
              rules={[{ required: true, message: '실습 기관을 입력하세요' }]}
            >
              <Input size="large" name='institute' placeholder="실습기관" prefix={<BankOutlined />} 
                defaultValue={this.state.institute}
              />
            </Form.Item>

            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>실습 개요</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="practice"
              rules={[{ required: true, message: '실습 개요를 입력하세요' }]}
            >
              <Input size="large" name='practice' placeholder="실습개요" prefix={<TagOutlined />} 
                defaultValue={this.state.practice}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>졸업 역량</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="competency"
              rules={[{ required: true, message: '졸업 역량을 입력하세요' }]}
            >

              <Select
                      mode="multiple"
                      size='large'
                      placeholder="졸업 역량 선택(여러개)"
                      // onChange={handleChange}
                      style={{ width: '100%' }}
                      optionLabelProp="label"
                      defaultValue={this.state.competency ? this.state.competency.split(' ') : []}
                    >
                    <Option value='BS' label='BS'>기초생명의학 지식(BS)</Option>
                    <Option value='CD' label='CD'>임상적 의사결정 능력(CD)</Option>
                    <Option value='CSIA' label='CSIA'>개별 동물에서의 건강과 질병 관리를 위한 임상 기술 (CSIA)</Option>
                    <Option value='MAH' label='MAH'>군집동물의 건강과 질병 관리(MAH)</Option>
                    <Option value='OHPH' label='OHPH'>원헬스와 공중보건 전문성(OHPH)</Option>
                    <Option value='SC' label='SC'>학문과 연구 (SC)</Option>
                    <Option value='VP' label='VP'>수의전문직업성(VP)</Option>
                    <Option value='CAC' label='CAC'>소통과 협력(CAC)</Option>
              </Select>
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>비고</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="etc"
              rules={[{ required: false, message: '비고를 입력하세요' }]}
            >
              <Input size="large" name='etc' placeholder="비고" 
                defaultValue={this.state.etc}
               />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>실습 담당자</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="professor"
              rules={[{ required: true, message: '실습 담당자를 입력하세요' }]}
            >
              <Input size="large" name='professor' placeholder="실습 담당자" prefix={<UserOutlined />} 
                defaultValue={this.state.professor}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>실습 담당자 연락처</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="professor_phone"
              rules={[{ required: true, message: '실습 담당자 연락처를 입력하세요' }]}
            >
              <Input size="large" name='professor_phone' placeholder="실습 담당자 연락처" prefix={<UserOutlined />} 
                defaultValue={this.state.professor_phone}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>실습 성과</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="report"
              rules={[{ required: true, message: '실습을 통한 역량 성취에 대해 간략하게 정리해주세요' }]}
            >
              <TextArea size="large"
              autoSize={{ minRows: 3, maxRows: 20 }}
              name='report'
              placeholder='실습을 통한 역량 성취에 대해 간략하게 정리해주세요' prefix={<ProfileOutlined />} 
                defaultValue={this.state.report}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>실습 보고서 (첨부파일)</Col>
            <Col flex="auto" className='row-content'>
              <Upload
                action="/api/record/upload_report"
                // data={{}}
                headers= {{
                  'authorization': `Bearer ${store.getState().token}`,
                  // 'content-type': 'multipart/form-data' 
                }}
                listType="picture-card"
                fileList={this.state.reportList}
                onChange={this.onChangeReport}
                onPreview={this.onPreview}
                progress={{ strokeWidth: 2, showInfo: false }}
                defaultValue={this.state.data.record_report_urls}

              >
                {this.state.reportList.length < 5 && '+ Upload'}
              </Upload>
            </Col>
          </Row>

          <Row className='last-row'>
            <Col flex="20%" className='row-title'>관련 이미지</Col>
            <Col flex="auto" className='row-content'>
            <Upload
              action="/api/record/upload_image"
              // data={{}}
              headers= {{
                'authorization': `Bearer ${store.getState().token}`,
                // 'content-type': 'multipart/form-data' 
              }}
              listType="picture-card"
              fileList={this.state.fileList}
              onChange={this.onChange}
              onPreview={this.onPreview}
              progress={{ strokeWidth: 2, showInfo: false }}
              multiple={true}
            >
              {this.state.fileList.length < 5 && '+ Upload'}
            </Upload>
            {/* <Form.Item
              name="report"
              rules={[{ required: true, message: '이미지를 선택하세요' }]}
            >
              <Input size="large" type='file' name='image' placeholder="실습 이미지" prefix={<UserOutlined />} />
            </Form.Item> */}
            </Col>
            
          </Row>
          </>
          :
          ''
          }
          {this.state.primary_class == '활동' ? 
          <>
          <Row>
            <Col flex="20%" className='row-title'>활동 기간</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="date_range"
              rules={[{ required: true, message: '활동 기간 입력하세요' }]}
            >
              <RangePicker
                style={{
                  width:'100%'
                }}
                format="YYYY/MM/DD"
                name='date_range'
                size="large"
                prefix={<CalendarOutlined />} 
                dateRender={current => {
                  const style = {};
                  if (current.date() === 1) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                  }
                  return (
                    <div className="ant-picker-cell-inner" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>활동 제목</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="institute"
              rules={[{ required: true, message: '활동 제목을 입력하세요' }]}
            >
              <Input size="large" name='institute' placeholder="활동제목" prefix={<BankOutlined />} />
            </Form.Item>

            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>활동 개요</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="practice"
              rules={[{ required: true, message: '활동 개요를 입력하세요' }]}
            >
              <Input size="large" name='practice' placeholder="활동개요" prefix={<TagOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>졸업 역량</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="competency"
              rules={[{ required: true, message: '졸업 역량을 입력하세요' }]}
            >

              <Select
                      mode="multiple"
                      size='large'
                      placeholder="졸업 역량 선택(여러개)"
                      // onChange={handleChange}
                      style={{ width: '100%' }}
                      optionLabelProp="label"
                    >
                    <Option value='BS' label='BS'>기초생명의학 지식(BS)</Option>
                    <Option value='CD' label='CD'>임상적 의사결정 능력(CD)</Option>
                    <Option value='CSIA' label='CSIA'>개별 동물에서의 건강과 질병 관리를 위한 임상 기술 (CSIA)</Option>
                    <Option value='MAH' label='MAH'>군집동물의 건강과 질병 관리(MAH)</Option>
                    <Option value='OHPH' label='OHPH'>원헬스와 공중보건 전문성(OHPH)</Option>
                    <Option value='SC' label='SC'>학문과 연구 (SC)</Option>
                    <Option value='VP' label='VP'>수의전문직업성(VP)</Option>
                    <Option value='CAC' label='CAC'>소통과 협력(CAC)</Option>
              </Select>
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>비고</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="etc"
              rules={[{ required: false, message: '비고를 입력하세요' }]}
            >
              <Input size="large" name='etc' placeholder="비고"  />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>활동 지도 전문가</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="professor"
            >
              <Input size="large" name='professor' placeholder="활동 지도 담당자" prefix={<UserOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>전문가 연락처</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="professor_phone"
            >
              <Input size="large" name='professor_phone' placeholder="전문가 연락처" prefix={<UserOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>활동 성과</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="report"
              rules={[{ required: true, message: '활동을 통한 역량 성취에 대해 간략하게 정리해주세요' }]}
            >
              <TextArea size="large"
              autoSize={{ minRows: 3, maxRows: 20 }}
              name='report'
              placeholder='활동을 통한 역량 성취에 대해 간략하게 정리해주세요' prefix={<ProfileOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>활동 보고서 (첨부파일)</Col>
            <Col flex="auto" className='row-content'>
              <Upload
                action="/api/record/upload_report"
                // data={{}}
                headers= {{
                  'authorization': `Bearer ${store.getState().token}`,
                  // 'content-type': 'multipart/form-data' 
                }}
                listType="picture-card"
                fileList={this.state.reportList}
                onChange={this.onChangeReport}
                onPreview={this.onPreview}
                progress={{ strokeWidth: 2, showInfo: false }}
              >
                {this.state.reportList.length < 5 && '+ Upload'}
              </Upload>
            </Col>
          </Row>

          <Row className='last-row'>
            <Col flex="20%" className='row-title'>관련 이미지</Col>
            <Col flex="auto" className='row-content'>
            <Upload
              action="/api/record/upload_image"
              // data={{}}
              headers= {{
                'authorization': `Bearer ${store.getState().token}`,
                // 'content-type': 'multipart/form-data' 
              }}
              listType="picture-card"
              fileList={this.state.fileList}
              onChange={this.onChange}
              onPreview={this.onPreview}
              progress={{ strokeWidth: 2, showInfo: false }}
              multiple={true}
            >
              {this.state.fileList.length < 5 && '+ Upload'}
            </Upload>
            {/* <Form.Item
              name="report"
              rules={[{ required: true, message: '이미지를 선택하세요' }]}
            >
              <Input size="large" type='file' name='image' placeholder="실습 이미지" prefix={<UserOutlined />} />
            </Form.Item> */}
            </Col>
            
          </Row>
          </>
          : 
          ''}
          {this.state.primary_class=='자기학습' ? 
          <>
          <Row>
            <Col flex="20%" className='row-title'>자기학습 기간</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="date_range"
              rules={[{ required: true, message: '자기학습 기간 입력하세요' }]}
            >
              <RangePicker
                style={{
                  width:'100%'
                }}
                format="YYYY/MM/DD"
                name='date_range'
                size="large"
                prefix={<CalendarOutlined />} 
                dateRender={current => {
                  const style = {};
                  if (current.date() === 1) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                  }
                  return (
                    <div className="ant-picker-cell-inner" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
              />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>자기학습 개요</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="practice"
              rules={[{ required: true, message: '자기학습 개요를 입력하세요' }]}
            >
              <Input size="large" name='practice' placeholder="자기학습 개요" prefix={<TagOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>졸업 역량</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="competency"
              rules={[{ required: true, message: '졸업 역량을 입력하세요' }]}
            >

              <Select
                      mode="multiple"
                      size='large'
                      placeholder="졸업 역량 선택(여러개)"
                      // onChange={handleChange}
                      style={{ width: '100%' }}
                      optionLabelProp="label"
                    >
                    <Option value='BS' label='BS'>기초생명의학 지식(BS)</Option>
                    <Option value='CD' label='CD'>임상적 의사결정 능력(CD)</Option>
                    <Option value='CSIA' label='CSIA'>개별 동물에서의 건강과 질병 관리를 위한 임상 기술 (CSIA)</Option>
                    <Option value='MAH' label='MAH'>군집동물의 건강과 질병 관리(MAH)</Option>
                    <Option value='OHPH' label='OHPH'>원헬스와 공중보건 전문성(OHPH)</Option>
                    <Option value='SC' label='SC'>학문과 연구 (SC)</Option>
                    <Option value='VP' label='VP'>수의전문직업성(VP)</Option>
                    <Option value='CAC' label='CAC'>소통과 협력(CAC)</Option>
              </Select>
            </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col flex="20%" className='row-title'>비고</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="etc"
              rules={[{ required: false, message: '비고를 입력하세요' }]}
            >
              <Input size="large" name='etc' placeholder="비고"  />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>자기학습 성과</Col>
            <Col flex="auto" className='row-content'>
            <Form.Item
              name="report"
              rules={[{ required: true, message: '자기학습을 통한 역량 성취에 대해 간략하게 정리해주세요' }]}
            >
              <TextArea size="large"
              autoSize={{ minRows: 3, maxRows: 20 }}
              name='report'
              placeholder='자기학습을 통한 역량 성취에 대해 간략하게 정리해주세요' prefix={<ProfileOutlined />} />
            </Form.Item>
            </Col>
          </Row>
          <Row className='last-row'>
            <Col flex="20%" className='row-title'>자기학습 성과 보고서 (첨부파일)</Col>
            <Col flex="auto" className='row-content'>
              <Upload
                action="/api/record/upload_report"
                // data={{}}
                headers= {{
                  'authorization': `Bearer ${store.getState().token}`,
                  // 'content-type': 'multipart/form-data' 
                }}
                listType="picture-card"
                fileList={this.state.reportList}
                onChange={this.onChangeReport}
                // onPreview={this.onPreview}
                progress={{ strokeWidth: 2, showInfo: false }}
              >
                {this.state.reportList.length < 5 && '+ Upload'}
              </Upload>
            </Col>
          </Row>

          <Row className='last-row'>
            <Col flex="20%" className='row-title'>관련 이미지</Col>
            <Col flex="auto" className='row-content'>
            <Upload
              action="/api/record/upload_image"
              // data={{}}
              headers= {{
                'authorization': `Bearer ${store.getState().token}`,
                // 'content-type': 'multipart/form-data' 
              }}
              listType="picture-card"
              fileList={this.state.fileList}
              onChange={this.onChange}
              onPreview={this.onPreview}
              progress={{ strokeWidth: 2, showInfo: false }}
              multiple={true}
            >
              {this.state.fileList.length < 5 && '+ Upload'}
            </Upload>
            {/* <Form.Item
              name="report"
              rules={[{ required: true, message: '이미지를 선택하세요' }]}
            >
              <Input size="large" type='file' name='image' placeholder="실습 이미지" prefix={<UserOutlined />} />
            </Form.Item> */}
            </Col>
            
          </Row>
          </>
          : 
          ''}

          <Divider orientation="center">
            <Form.Item noStyle >
              <Button htmlType="submit" type="primary_class" size='large'>제출</Button>
            </Form.Item>
          </Divider>
          </Form>
        </Content>

      </Layout>
      ) 
  };
};